import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './allergy.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class AllergyDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const allergyType = isNullOrWhiteSpace(this.props.allergy.allergyTypeDisplay) ?
      this.props.allergy.allergyType : this.props.allergy.allergyTypeDisplay;

    return (
      this.props.allergy.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'allergy_' + this.props.allergy.allergen}>
        <div className="col-md-4 primary-data">
          {
            this.props.allergy.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          <span className="list-item">{this.props.allergy.allergen}</span>
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.allergyType} />}
                value={allergyType} language={this.props.language}
                isActive={this.configurationActive('AllergyType')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.onsetDate} />}
                value={this.props.allergy.onsetDate} language={this.props.language} isDate
                isActive={this.configurationActive('OnsetDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.response} />}
                value={this.props.allergy.response} language={this.props.language}
                isActive={this.configurationActive('Response')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.allergy.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="allergy_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.allergy.nullMessage}
        </div>
      </div>
    );
  }
}

AllergyDetail.propTypes = {
  allergy: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
